function getDemoUrl(index) {
  if (index === 1) return 'https://www.dm99.v588.co';
  return `https://www.dm99${String(index).padStart(2, '0')}.v588.co`;
}

export const mobileTemplates = [
  { num: 1, id: '01', label: 'DOING-01', url: getDemoUrl(1) },
  { num: 2, id: '02', label: 'DOING-02', url: getDemoUrl(2) },
  { num: 3, id: '03', label: 'DOING-03', url: getDemoUrl(3) },
  { num: 4, id: '04', label: 'DOING-04', url: getDemoUrl(4) },
  { num: 5, id: '05', label: 'DOING-05', url: getDemoUrl(5) },
  { num: 6, id: '06', label: 'DOING-06', url: getDemoUrl(6) },
  { num: 7, id: '07', label: 'DOING-07', url: getDemoUrl(7) },
  { num: 8, id: '08', label: 'DOING-08', url: getDemoUrl(8) },
  { num: 9, id: '09', label: 'DOING-09', url: getDemoUrl(9) },
  { num: 11, id: '11', label: 'DOING-11', url: getDemoUrl(11) },
  { num: 12, id: '12', label: 'DOING-12', url: getDemoUrl(12) },
  { num: 13, id: '13', label: 'DOING-13', url: getDemoUrl(13) },
  { num: 14, id: '14', label: 'DOING-14', url: getDemoUrl(14) },
  { num: 15, id: '15', label: 'DOING-15', url: getDemoUrl(15) },
  { num: 16, id: '16', label: 'DOING-16', url: getDemoUrl(16) },
  { num: 17, id: '17', label: 'DOING-17', url: getDemoUrl(17) },
  { num: 20, id: '20', label: 'DOING-20', url: getDemoUrl(20) },
  { num: 21, id: '21', label: 'DOING-21', url: null },
].map(item => ({ ...item, image: require(`@/assets/images/templateCase/mobile/${item.id}.jpg`) }));

export const creditTemplates = [
  { id: 'CREDIT-01', label: '信用版-01', url: null, image: require('@/assets/images/templateCase/credit/1.jpg') },
  { id: 'CREDIT-02', label: '信用版-02', url: null, image: require('@/assets/images/templateCase/credit/2.jpg') },
];
export { getDemoUrl };
